import ContactTagsView from "@/components/features/settings/defaults/contact-tags/ContactTagsView";

export default function ContactDefaults() {
  return (
    <div className="flex flex-col gap-6">
      <ContactTagsView />
    </div>
  );
}
